import { render, staticRenderFns } from "./LicenseAssign.vue?vue&type=template&id=baa9e666&scoped=true&"
import script from "./LicenseAssign.vue?vue&type=script&lang=js&"
export * from "./LicenseAssign.vue?vue&type=script&lang=js&"
import style0 from "./LicenseAssign.vue?vue&type=style&index=0&id=baa9e666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9e666",
  null
  
)

export default component.exports